import httpClient from './auth-http-client'
import { success, failure, type ApiResult } from './api-result'

// Impersonation is *started* from the Lightbase admin app. This product app only
// needs to close out the session on exit (authorized as the impersonated user).
export async function endImpersonation(sessionId: string): Promise<ApiResult<{ ok: boolean }>> {
    try {
        const response = await httpClient.post('/lightbase/impersonate/end', {
            session_id: sessionId,
        })
        if (response.status === 200) return success(response.data)
        return failure(response.data?.detail || 'Failed to end impersonation', response.status)
    } catch (e: any) {
        return failure(e?.message || 'Failed to end impersonation')
    }
}
